import { ReactNode } from 'react';

import { Box, List, ListItem, Typography } from '@mui/material';

import clsx from 'clsx';

interface OfferingDataListProps {
  className?: string;
  children?: ReactNode;
  title: ReactNode | string;
}
export const OfferingDataList = ({ className, title, children }: OfferingDataListProps) => {
  return (
    <Box className={clsx(className)}>
      <Typography
        variant="h5.medium"
        pb={1}
        mb={1}
        borderBottom={(theme) => `1px solid ${theme.palette.neutrals.platinum}`}
      >
        {title}
      </Typography>
      <List disablePadding>{children}</List>
    </Box>
  );
};

interface OfferingDataListItemProps {
  className?: string;
  left: ReactNode;
  right: ReactNode;
}

export const OfferingDataListItem = ({ className, left, right }: OfferingDataListItemProps) => {
  return (
    <ListItem className={className} disableGutters secondaryAction={right}>
      {left}
    </ListItem>
  );
};
